import { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  Alert,
  CircularProgress,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { reportesAPI } from '../services/api';
import { useAuthStore } from '../store/authStore';

export default function Reportes() {
  const { user } = useAuthStore();
  const [fecha, setFecha] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleEnviarReporte = async () => {
    if (!fecha || !email) {
      setMessage({ type: 'error', text: 'Complete todos los campos' });
      return;
    }

    setLoading(true);
    setMessage(null);

    try {
      const response = await reportesAPI.viajesDiariosEmail({
        fecha,
        organizacion: user.organizacion,
        email,
      });

      if (response.data.estado === 1) {
        setMessage({ type: 'success', text: 'Reporte enviado exitosamente' });
        setFecha('');
        setEmail('');
      } else {
        setMessage({ type: 'error', text: 'Error al enviar reporte' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Error al enviar reporte' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Reportes
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Reporte de Viajes Diarios por Email
        </Typography>

        {message && (
          <Alert severity={message.type} sx={{ mb: 3 }}>
            {message.text}
          </Alert>
        )}

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="date"
              label="Fecha"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@ejemplo.com"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              startIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
              onClick={handleEnviarReporte}
              disabled={loading}
            >
              {loading ? 'Enviando...' : 'Enviar Reporte'}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
